import script from "./SlimPageContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./SlimPageContainer.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__